"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeDatePicker = exports.InputFieldType = void 0;
var classnames_1 = require("classnames");
var date_fns_1 = require("date-fns");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var ButtonAction_1 = require("../ButtonAction");
var Calendar_1 = require("../Calendar");
var ErrorMessage_1 = require("../ErrorMessage");
var Icon_1 = require("../Icon");
var InputFieldType;
(function (InputFieldType) {
    InputFieldType[InputFieldType["Start"] = 0] = "Start";
    InputFieldType[InputFieldType["End"] = 1] = "End";
})(InputFieldType = exports.InputFieldType || (exports.InputFieldType = {}));
exports.RangeDatePicker = (0, react_1.forwardRef)(function (_a, ref) {
    var calendarChildren = _a.calendarChildren, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.dateFormat, dateFormat = _c === void 0 ? 'dd/MM/yyyy' : _c, displayInline = _a.displayInline, _d = _a.errormessage, errormessage = _d === void 0 ? '' : _d, id = _a.id, initialCalendarMonth = _a.initialCalendarMonth, _e = _a.initialDateRange, initialDateRange = _e === void 0 ? { startDate: '', endDate: '' } : _e, _f = _a.isValidRange, isValidRange = _f === void 0 ? { start: true, end: true } : _f, label = _a.label, maximumDate = _a.maximumDate, minimumDate = _a.minimumDate, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, screenReaderText = _a.screenReaderText, _g = _a.shouldSetDateRange, shouldSetDateRange = _g === void 0 ? false : _g, _h = _a.value, value = _h === void 0 ? { startDate: '', endDate: '' } : _h;
    var modRef = (React.useRef());
    var calRef = (React.useRef());
    var now = new Date();
    var smallScreenSize = 768;
    var screenText = screenReaderText ? screenReaderText : 'Enter start and end date using text field or continue navigating to use the date picker.';
    var _j = (0, react_1.useState)(initialDateRange.startDate ? new Date(initialDateRange.startDate) : null), selectedStartDate = _j[0], setSelectedStartDate = _j[1];
    var _k = (0, react_1.useState)(initialDateRange.endDate ? new Date(initialDateRange.endDate) : null), selectedEndDate = _k[0], setSelectedEndDate = _k[1];
    var _l = (0, react_1.useState)(''), inputStartDate = _l[0], setInputStartDate = _l[1];
    var _m = (0, react_1.useState)(false), isInputStartSelectedByCalendar = _m[0], setIsInputStartSelectedByCalendar = _m[1];
    var _o = (0, react_1.useState)(false), isInputEndSelectedByCalendar = _o[0], setIsInputEndSelectedByCalendar = _o[1];
    var _p = (0, react_1.useState)(''), inputEndDate = _p[0], setInputEndDate = _p[1];
    var _q = (0, react_1.useState)(InputFieldType.Start), selectedInputField = _q[0], setSelectedInputField = _q[1];
    var _r = (0, react_1.useState)('initialLoad'), calOneActive = _r[0], setCalOneActive = _r[1];
    var _s = (0, react_1.useState)('inactive'), calTwoActive = _s[0], setCalTwoActive = _s[1];
    var _t = (0, react_1.useState)(false), calendarInFocus = _t[0], setCalendarInFocus = _t[1];
    var _u = (0, react_1.useState)(displayInline), showCalendar = _u[0], setShowCalendar = _u[1];
    var _v = (0, react_1.useState)(true), displayCalBottom = _v[0], setDisplayCalBottom = _v[1];
    /**
     * set inital start month displayed for the calendar
     * @returns date | null
     */
    var getInitialStartMonth = function () {
        if (value.startDate) {
            return (0, date_fns_1.parse)(value.startDate, dateFormat, now);
        }
        if (value.endDate) {
            return (0, date_fns_1.parse)(value.startDate, dateFormat, now);
        }
        if (initialCalendarMonth) {
            return initialCalendarMonth;
        }
        return null;
    };
    var initalStartMonth = getInitialStartMonth();
    var _w = (0, react_1.useState)(null), focusDate = _w[0], setFocusDate = _w[1];
    var _x = (0, react_1.useState)(initalStartMonth !== null && initalStartMonth !== void 0 ? initalStartMonth : now), firstCalendarMonthYear = _x[0], setFirstCalendarMonthYear = _x[1];
    var _y = (0, react_1.useState)(initalStartMonth ? (0, date_fns_1.addMonths)(initalStartMonth, 1) : (0, date_fns_1.addMonths)(now, 1)), secondCalendarMonthYear = _y[0], setSecondCalendarMonthYear = _y[1];
    /**
     * Input date checker
     * Function is used to check if a date is a valid date, and in range
     * Called in initial useEffect of setting start date, on input focus and on input blur
     */
    var isDateValid = function (checkDate) {
        var isValidStartDate = true;
        if (!(0, date_fns_1.isValid)(checkDate)) {
            return false;
        }
        if (maximumDate) {
            isValidStartDate = isValidStartDate && (0, date_fns_1.isAfter)(maximumDate, checkDate);
        }
        if (minimumDate) {
            isValidStartDate = isValidStartDate && (0, date_fns_1.isBefore)(minimumDate, checkDate);
        }
        return isValidStartDate;
    };
    (0, react_1.useEffect)(function () {
        if (shouldSetDateRange) {
            var current = new Date();
            setInputStartDate(initialDateRange.startDate);
            setInputEndDate(initialDateRange.endDate);
            if (isValidRange.start && isValidRange.end && initialDateRange.startDate) {
                var parsedStart = (0, date_fns_1.parse)(initialDateRange.startDate, dateFormat, current);
                setSelectedStartDate(parsedStart);
                setSelectedEndDate((0, date_fns_1.parse)(initialDateRange.endDate, dateFormat, current));
                setFirstCalendarMonthYear(parsedStart);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedStart, 1));
            }
            else {
                setSelectedStartDate(null);
                setSelectedEndDate(null);
                setFirstCalendarMonthYear(initialCalendarMonth !== null && initialCalendarMonth !== void 0 ? initialCalendarMonth : current);
                setSecondCalendarMonthYear(initialCalendarMonth ? (0, date_fns_1.addMonths)(initialCalendarMonth, 1) : (0, date_fns_1.addMonths)(current, 1));
            }
            setSelectedInputField(InputFieldType.Start);
        }
    }, [
        shouldSetDateRange,
        dateFormat,
        isValidRange.end,
        isValidRange.start,
        initialDateRange.startDate,
        initialDateRange.endDate,
        initialCalendarMonth,
    ]);
    /**
     * Set initial start date and end date
     * Watch for invalid start date and clear field if it is true
     * set the correct calendar in view if date is valid
     */
    (0, react_1.useEffect)(function () {
        var current = new Date();
        setInputStartDate(value.startDate);
        setInputEndDate(value.endDate);
        var isValidStart = isValidRange.start;
        var isValidEnd = isValidRange.end;
        // set selected days on calendars
        if (isValidStart) {
            var parsedStart = (0, date_fns_1.parse)(value.startDate, dateFormat, current);
            if (isDateValid(parsedStart)) {
                setSelectedStartDate(parsedStart);
            }
            else {
                setSelectedStartDate(null);
            }
        }
        else {
            setSelectedStartDate(null);
        }
        if (isValidEnd) {
            var parsedEnd = (0, date_fns_1.parse)(value.endDate, dateFormat, current);
            if (isDateValid(parsedEnd)) {
                setSelectedEndDate(parsedEnd);
            }
            else {
                setSelectedEndDate(null);
            }
        }
        else {
            setSelectedEndDate(null);
        }
        // set calendars month
        if (isValidStart && value.startDate) {
            var parsedStart = (0, date_fns_1.parse)(value.startDate, dateFormat, current);
            if (isDateValid(parsedStart)) {
                setFirstCalendarMonthYear(parsedStart);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedStart, 1));
                return;
            }
        }
        if (isValidEnd && value.endDate) {
            var parsedEnd = (0, date_fns_1.parse)(value.endDate, dateFormat, current);
            if (isDateValid(parsedEnd)) {
                setFirstCalendarMonthYear(parsedEnd);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedEnd, 1));
                return;
            }
        }
        setFirstCalendarMonthYear(initialCalendarMonth !== null && initialCalendarMonth !== void 0 ? initialCalendarMonth : current);
        setSecondCalendarMonthYear(initialCalendarMonth ? (0, date_fns_1.addMonths)(initialCalendarMonth, 1) : (0, date_fns_1.addMonths)(current, 1));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isValidRange.end, isValidRange.start, dateFormat]);
    /**
     * Handle Calendar display position
     * If the calendar is not set to display inline check to see if there is space below the input field to display.
     * If this is not the case, check if there is space to display the calendar above the input field.
     * If this is not the case display below.
     */
    (0, react_1.useEffect)(function () {
        if (calendarInFocus && modRef.current) {
            if (displayCalBottom) {
                if (calRef.current.getBoundingClientRect().bottom + window.scrollY > window.innerHeight) {
                    if (calRef.current.getBoundingClientRect().top > calRef.current.getBoundingClientRect().height) {
                        setDisplayCalBottom(false);
                        return;
                    }
                }
            }
        }
        setDisplayCalBottom(true);
        // eslint-disable-next-line
    }, [calendarInFocus]);
    /**
     * Input field Focus handler
     * check if focus is on start date or end date
     * check value is a valid date
     * set the calendar to in view if a valid date
     */
    var onInputFocus = function (event) {
        event.preventDefault();
        var inputString = event.target.value;
        if (event.target.name === name + "StartDate") {
            if (!displayInline) {
                hideShowCalendar(false);
            }
            setIsInputStartSelectedByCalendar(false);
            setSelectedInputField(InputFieldType.Start);
        }
        else {
            if (!displayInline) {
                hideShowCalendar(false);
            }
            setIsInputEndSelectedByCalendar(false);
            setSelectedInputField(InputFieldType.End);
        }
        // if input field already has a value, set the calendar month to that value.
        if (inputString) {
            var inputDate = (0, date_fns_1.parse)(inputString, dateFormat, now);
            var isValidStart = isValidRange.start && isDateValid(inputDate);
            var isValidEnd = isValidRange.end && isDateValid(inputDate);
            var oneCalView = window.innerWidth < smallScreenSize;
            if (isValidStart || isValidEnd) {
                // if both the start date and end date have a value and are 1 month apart set the first calendar to start date
                if (event.target.name === name + "EndDate" && inputStartDate) {
                    var startMonth = (0, date_fns_1.getMonth)((0, date_fns_1.parse)(inputStartDate, dateFormat, now));
                    var endMonth = (0, date_fns_1.getMonth)(inputDate);
                    if (startMonth === (endMonth - 1) && !oneCalView) {
                        setFirstCalendarMonthYear((0, date_fns_1.addMonths)(inputDate, -1));
                        setSecondCalendarMonthYear(inputDate);
                        if (!displayInline) {
                            setFocusDate(inputDate);
                        }
                    }
                    else {
                        setFirstCalendarMonthYear(inputDate);
                        setSecondCalendarMonthYear((0, date_fns_1.addMonths)(inputDate, 1));
                        setFocusDate(inputDate);
                    }
                }
                else {
                    setFirstCalendarMonthYear(inputDate);
                    setSecondCalendarMonthYear((0, date_fns_1.addMonths)(inputDate, 1));
                    setFocusDate(inputDate);
                }
            }
        }
        if (onFocus) {
            onFocus(event);
        }
    };
    var onPreviousMonthBtnClick = function () {
        changeMonthDisplay('previous');
        // activate calendar that should be in focus. handle when button is clicked multipe times
        setCalOneActive(calOneActive === 'button-click' ? 'button-click2' : 'button-click');
        setCalTwoActive('inactive');
    };
    var onNextMonthBtnClick = function () {
        changeMonthDisplay('next');
        // activate calendar that should be in focus. handle when button is clicked multipe times
        setCalOneActive(calOneActive === 'button-click' ? 'button-click2' : 'button-click');
        setCalTwoActive('inactive');
    };
    /**
     * Input field on blur handler
     * validate the date
     * set the date in the calendar
     * activate the calendar if position absolute
     */
    var onInputBlur = function (event) {
        if (onBlur) {
            onBlur(event);
        }
        var parsedDateStart = (0, date_fns_1.parse)(inputStartDate, dateFormat, now);
        var parsedDateEnd = (0, date_fns_1.parse)(inputEndDate, dateFormat, now);
        var isStartValid = isValidRange.start && isDateValid(parsedDateStart);
        var isEndValid = isValidRange.end && isDateValid(parsedDateEnd);
        var isEndAfterStart = (isStartValid === true && isEndValid === true) ? (0, date_fns_1.isAfter)(parsedDateEnd, parsedDateStart) : true;
        var oneCalView = window.innerWidth < smallScreenSize;
        // activate calendar that should be in focus. handle when button is clicked multipe times and incorrect date
        if (!isStartValid && !isEndValid) {
            setCalOneActive('start-date-invalid');
            setCalTwoActive('inactive');
        }
        else if (!isStartValid && isEndValid) {
            setCalOneActive(calOneActive === 'end-date' ? 'end-date' : 'end-date2');
            setCalTwoActive('inactive');
        }
        else if (isStartValid && !isEndValid) {
            setCalOneActive(calOneActive === 'start-date' ? 'start-date' : 'start-date2');
            setCalTwoActive('inactive');
        }
        else if ((0, date_fns_1.getMonth)(parsedDateStart) === ((0, date_fns_1.getMonth)(parsedDateEnd) - 1) && !oneCalView) {
            if (!displayInline && !oneCalView) {
                if (event.target.name === name + "StartDate") {
                    setCalOneActive(calOneActive === 'start-date' ? 'start-date' : 'start-date2');
                    setCalTwoActive('inactive');
                }
                else {
                    setCalOneActive('inactive');
                    setCalTwoActive(calTwoActive === 'start-date' ? 'start-date' : 'start-date2');
                }
            }
            else {
                setCalOneActive(calOneActive === 'start-date' ? 'start-date' : 'start-date2');
                setCalTwoActive('inactive');
            }
        }
        else {
            if (calOneActive === 'start-date' || calOneActive === 'initialLoad') {
                setCalOneActive(calOneActive === 'start-date' ? 'start-date2' : 'initialLoad');
            }
            else {
                setCalOneActive(calOneActive === 'end-date' ? 'end-date' : 'end-date2');
            }
            setCalTwoActive('inactive');
        }
        if (!isStartValid && !isEndValid) {
            setSelectedEndDate(null);
            setSelectedStartDate(null);
            setFirstCalendarMonthYear(now);
            setSecondCalendarMonthYear((0, date_fns_1.addMonths)(now, 1));
            return;
        }
        if (isStartValid && isEndValid) {
            setSelectedStartDate(parsedDateStart);
            if (isEndAfterStart) {
                setSelectedEndDate(parsedDateEnd);
            }
            else {
                setSelectedEndDate(null);
            }
            if (event.target.name === name + "StartDate") {
                setFirstCalendarMonthYear(parsedDateStart);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedDateStart, 1));
            }
            else if ((0, date_fns_1.getMonth)(parsedDateStart) === ((0, date_fns_1.getMonth)(parsedDateEnd) - 1) && !oneCalView) {
                setFirstCalendarMonthYear(parsedDateStart);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedDateStart, 1));
            }
            else {
                setFirstCalendarMonthYear(parsedDateEnd);
                setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedDateEnd, 1));
            }
            return;
        }
        if (isStartValid) {
            setSelectedEndDate(null);
            setSelectedStartDate(parsedDateStart);
            setFirstCalendarMonthYear(parsedDateStart);
            setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedDateStart, 1));
        }
        else {
            setSelectedStartDate(null);
            setSelectedEndDate(parsedDateEnd);
            setFirstCalendarMonthYear(parsedDateEnd);
            setSecondCalendarMonthYear((0, date_fns_1.addMonths)(parsedDateEnd, 1));
        }
    };
    var onInputChange = function (event) {
        var inputValue = event.target.value;
        if (event.target.name === name + "StartDate") {
            setInputStartDate(inputValue);
            if (onChange) {
                onChange(name, { startDate: inputValue, endDate: inputEndDate });
            }
        }
        else {
            setInputEndDate(inputValue);
            if (onChange) {
                onChange(name, { startDate: inputStartDate, endDate: inputValue });
            }
        }
    };
    var onCalendarDayClick = function (event) {
        var dataset = event.currentTarget.dataset;
        if (!dataset.day && !dataset.year && !dataset.month) {
            /* istanbul ignore next */
            return;
        }
        var selectedDate = new Date(Number(dataset.year), Number(dataset.month), Number(dataset.day));
        // not needed for netbank.accounts. will turn on a param to set if required by other teams
        // if (selectedEndDate && isSameDay(selectedDate, selectedEndDate)) {
        //     return;
        // }
        // if (selectedStartDate && isSameDay(selectedDate, selectedStartDate)) {
        //     return;
        // }
        var formattedDate = (0, date_fns_1.format)(selectedDate, dateFormat);
        if (selectedInputField === InputFieldType.Start || selectedStartDate === null) {
            setSelectedStartDate(selectedDate);
            setInputStartDate(formattedDate);
            setIsInputStartSelectedByCalendar(true);
            if (onChange) {
                onChange(name + "StartDate", { startDate: formattedDate, endDate: inputEndDate });
            }
            if (isValidRange.end && selectedEndDate !== null && (0, date_fns_1.isAfter)(selectedDate, selectedEndDate)) {
                setSelectedEndDate(null);
                setInputEndDate('');
                if (onChange) {
                    onChange(name + "endDate", { startDate: inputStartDate, endDate: '' });
                }
            }
            setSelectedInputField(InputFieldType.End);
        }
        else if (selectedInputField === InputFieldType.End) {
            setSelectedEndDate(selectedDate);
            setInputEndDate(formattedDate);
            setIsInputEndSelectedByCalendar(true);
            if (onChange) {
                onChange(name + "EndDate", { startDate: inputStartDate, endDate: formattedDate });
            }
            if (isValidRange.start && selectedStartDate !== null && (0, date_fns_1.isBefore)(selectedDate, selectedStartDate)) {
                setSelectedStartDate(selectedDate);
                setInputStartDate(formattedDate);
                setSelectedEndDate(null);
                setInputEndDate('');
                if (onChange) {
                    onChange(name + "StartDate", { startDate: formattedDate, endDate: '' });
                }
                setSelectedInputField(InputFieldType.End);
            }
            else if (!displayInline) {
                hideShowCalendar(true, 1);
                setSelectedInputField(InputFieldType.Start);
            }
            else {
                setSelectedInputField(InputFieldType.Start);
            }
        }
    };
    var changeMonthDisplay = function (direction) {
        if (direction === 'previous') {
            var prevStartMonthYear = (0, date_fns_1.subMonths)(firstCalendarMonthYear, 1);
            if (minimumDate && (0, date_fns_1.isBefore)(prevStartMonthYear, minimumDate) && !(0, date_fns_1.isSameDay)(prevStartMonthYear, minimumDate)) {
                return;
            }
            setFirstCalendarMonthYear(prevStartMonthYear);
            setSecondCalendarMonthYear((0, date_fns_1.addMonths)(prevStartMonthYear, 1));
        }
        else {
            var nextStartMonthYear = (0, date_fns_1.addMonths)(firstCalendarMonthYear, 1);
            if (maximumDate && (0, date_fns_1.isAfter)(nextStartMonthYear, maximumDate)) {
                if ((0, date_fns_1.isSameMonth)(nextStartMonthYear, maximumDate) && window.innerWidth < smallScreenSize) {
                    setFirstCalendarMonthYear(nextStartMonthYear);
                    setSecondCalendarMonthYear((0, date_fns_1.addMonths)(nextStartMonthYear, 1));
                }
                else {
                    return;
                }
            }
            setFirstCalendarMonthYear(nextStartMonthYear);
            setSecondCalendarMonthYear((0, date_fns_1.addMonths)(nextStartMonthYear, 1));
        }
    };
    /**
     * Hide and show the calendar in absolute position
     * used to manage display and focus when the input, calendar icon and backdrop is clicked
     * if calendar or input icon is clicked, return focus to the input field
     */
    var hideShowCalendar = (0, react_1.useCallback)(function (returnFocus, hideCalendar) {
        if (returnFocus) {
            modRef.current.querySelector("#" + id + "-end-date-input").focus();
        }
        if (hideCalendar === 1) {
            setShowCalendar(false);
            setCalendarInFocus(false);
        }
        else if (showCalendar !== true) {
            setShowCalendar(!showCalendar);
            setCalendarInFocus(!calendarInFocus);
        }
    }, [setShowCalendar, setCalendarInFocus, calendarInFocus, showCalendar, id, modRef]);
    var onOuterMouseClick = (0, react_1.useCallback)(function (evt) {
        if (!displayInline) {
            setTimeout(function () {
                if (!modRef.current.contains(evt.target)) {
                    hideShowCalendar(false, 1);
                }
            }, 5);
        }
    }, [displayInline, hideShowCalendar, modRef]);
    /**
     * Handle Calendar display when focusing outside of the component
     */
    (0, react_1.useEffect)(function () {
        if (showCalendar) {
            // add eventListener just when calendar shown
            document.body.addEventListener('click', onOuterMouseClick);
        }
        else {
            // remove eventListener when calendar hidden
            document.body.removeEventListener('click', onOuterMouseClick);
        }
        return function () {
            // remove eventListener when calendar removed from DOM
            document.body.removeEventListener('click', onOuterMouseClick);
        };
    }, [onOuterMouseClick, showCalendar]);
    /**
     * handle calendar focus change when arrowing through the dates and both calendars are on the screen
     */
    var switchCalendarFocus = function (datefocus, calPosition) {
        if (calPosition === 1) {
            setFocusDate(datefocus);
            setCalOneActive(calOneActive === 'day-scroll' ? 'day-scroll2' : 'day-scroll');
            setCalTwoActive('inactive');
        }
        if (calPosition === 2) {
            setFocusDate(datefocus);
            setCalOneActive('inactive');
            setCalTwoActive(calOneActive === 'day-scroll' ? 'day-scroll2' : 'day-scroll');
        }
    };
    return (React.createElement("div", { className: "date-picker " + className, id: id, ref: modRef },
        React.createElement("span", { className: "sr-only" }, screenText),
        React.createElement("label", { htmlFor: id + "-start-date-input", className: (0, classnames_1.default)({ 'sr-only': !label }) }, label !== null && label !== void 0 ? label : "Start date " + dateFormat),
        React.createElement("div", { className: "d-flex justify-content-center" },
            React.createElement("div", null,
                React.createElement("input", { ref: !isValidRange.start ? ref : undefined, id: id + "-start-date-input", className: (0, classnames_1.default)('date-picker__input', {
                        'date-picker__input--is-invalid': !isValidRange.start && !isInputStartSelectedByCalendar,
                    }), name: name + "StartDate", type: "text", value: inputStartDate, placeholder: placeholder, onFocus: onInputFocus, onBlur: onInputBlur, onChange: onInputChange, "aria-describedby": !isValidRange.start && !isInputStartSelectedByCalendar ? id + "-errormessage" : undefined, "aria-invalid": !isValidRange.start && !isInputStartSelectedByCalendar }),
                React.createElement("input", { ref: !isValidRange.end ? ref : undefined, id: id + "-end-date-input", className: (0, classnames_1.default)('date-picker__input', {
                        'date-picker__input--is-invalid': !isValidRange.end && !isInputEndSelectedByCalendar,
                    }), name: name + "EndDate", type: "text", value: inputEndDate, placeholder: placeholder, onFocus: onInputFocus, onBlur: onInputBlur, onChange: onInputChange, "aria-label": "End date " + dateFormat, "aria-describedby": !isValidRange.end && !isInputEndSelectedByCalendar ? id + "-errormessage" : undefined, "aria-invalid": !isValidRange.end && !isInputEndSelectedByCalendar }),
                ((!isValidRange.start && !isInputStartSelectedByCalendar) ||
                    (!isValidRange.end && !isInputEndSelectedByCalendar)) &&
                    errormessage && React.createElement(ErrorMessage_1.ErrorMessage, { id: id, message: errormessage }))),
        React.createElement("div", { ref: calRef, hidden: !showCalendar && !displayInline, className: (0, classnames_1.default)({
                'date-picker__absolute': !displayInline,
                'date-picker__absolute-top': !displayInline && !displayCalBottom,
                'date-picker__inline': displayInline,
                'date-picker__single': window.innerWidth <= smallScreenSize && !displayInline,
                'date-picker__wide': window.innerWidth > smallScreenSize && !displayInline,
            }) },
            React.createElement("div", { className: displayInline ? 'date-picker__month mt-3 mt-md-4' : 'date-picker__month' },
                React.createElement(ButtonAction_1.ButtonActionSubtle, { className: "date-picker__month__btn", id: id + "-prev-month-btn", onClick: onPreviousMonthBtnClick, "aria-label": "Previous month" },
                    React.createElement(Icon_1.Icon, { symbol: "controlChevronForward24", type: "svgfile", className: "icon-rotated" })),
                React.createElement("span", { className: "date-picker__month__text mr-0 mr-md-9" }, (0, date_fns_1.format)(firstCalendarMonthYear, 'MMM yyyy')),
                React.createElement("span", { className: "date-picker__month__text d-none d-md-block" }, (0, date_fns_1.format)(secondCalendarMonthYear, 'MMM yyyy')),
                React.createElement(ButtonAction_1.ButtonActionSubtle, { className: "date-picker__month__btn", id: id + "-next-month-btn", onClick: onNextMonthBtnClick, "aria-label": "Next month" },
                    React.createElement(Icon_1.Icon, { symbol: "controlChevronForward24", type: "svgfile" }))),
            React.createElement("div", { className: "mt-2 w-100 calendar-container" },
                React.createElement(Calendar_1.Calendar, { id: id + "-first-calendar", isActive: calendarInFocus, month: (0, date_fns_1.getMonth)(firstCalendarMonthYear), year: (0, date_fns_1.getYear)(firstCalendarMonthYear), onClick: onCalendarDayClick, startDate: selectedStartDate, endDate: selectedEndDate, displayOnHover: !displayInline, className: "m-auto m-md-0", maximumDate: maximumDate, minimumDate: minimumDate, caption: (0, date_fns_1.format)(firstCalendarMonthYear, 'MMM yyyy'), onChangeCalendarMonth: changeMonthDisplay, onChangeCalendarStatus: switchCalendarFocus, calendarPosition: 1, inFocusChange: calOneActive, startFocusDate: focusDate, smallScreenSize: smallScreenSize }),
                React.createElement(Calendar_1.Calendar, { id: id + "-second-calendar", isActive: calendarInFocus, month: (0, date_fns_1.getMonth)(secondCalendarMonthYear), year: (0, date_fns_1.getYear)(secondCalendarMonthYear), onClick: onCalendarDayClick, displayOnHover: !displayInline, startDate: selectedStartDate, endDate: selectedEndDate, className: "ml-9 d-none d-md-table", maximumDate: maximumDate, minimumDate: minimumDate, caption: (0, date_fns_1.format)(secondCalendarMonthYear, 'MMM yyyy'), onChangeCalendarMonth: changeMonthDisplay, onChangeCalendarStatus: switchCalendarFocus, calendarPosition: 2, inFocusChange: calTwoActive, startFocusDate: focusDate, smallScreenSize: smallScreenSize })),
            calendarChildren && calendarChildren)));
});
exports.RangeDatePicker.defaultProps = {
    displayInline: true,
};
exports.RangeDatePicker.propTypes = {
    calendarChildren: PropTypes.any,
    className: PropTypes.string,
    dateFormat: PropTypes.string,
    displayInline: PropTypes.bool,
    errormessage: PropTypes.string,
    id: PropTypes.string.isRequired,
    initialCalendarMonth: PropTypes.instanceOf(Date),
    initialDateRange: PropTypes.object,
    isValidRange: PropTypes.object,
    label: PropTypes.string,
    maximumDate: PropTypes.instanceOf(Date),
    minimumDate: PropTypes.instanceOf(Date),
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    screenReaderText: PropTypes.string,
    shouldSetDateRange: PropTypes.bool,
    value: PropTypes.object,
};
exports.default = exports.RangeDatePicker;
